import { call, put, select, takeLatest } from "redux-saga/effects";
import qs from 'qs';
import { FETCH_VALUE_SELLING_CARD_REQUEST, fetchValueSellingCardFailure, fetchValueSellingCardSuccess } from "../../actions/opportunities/valueSellingCardActions";
import iq_api_v2 from "../../../../services/iqApiV2";

async function findValueSellingCardData(opportunityId="") {
    const data = qs.stringify({
      opportunity_id: opportunityId
    });
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post("/opportunities/get_value_selling_prompter_2", {
        opportunity_id: opportunityId
      }, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // console.log('Response:', response.data);
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchValueSellingCardSaga() {
  try {
    const payload = yield select(
      (state) => state?.valueSellingCardReducer?.payload
    );
    const { opportunityId=""} = payload;
    const data = yield call(
        findValueSellingCardData,
        opportunityId
    );
    yield put(fetchValueSellingCardSuccess(data));
  } catch (error) {
    yield put(fetchValueSellingCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchValueSellingCardData() {
  yield takeLatest(FETCH_VALUE_SELLING_CARD_REQUEST, fetchValueSellingCardSaga);
}
